import classnames from 'classnames'
import get from 'lodash/get'
import moment from 'moment'
import React, { Component } from 'react'
import { Query } from 'react-apollo'
import Loader from '../../../common/loader/Loader'
import type { OptionType } from '../../../common/select/Select'
import Select from '../../../common/select/Select'
import { alphaSort } from '../../../common/utils'
import { i18n } from '../../index'
import withActiveStation from '../../station/withActiveStation'
import MonthDisplay from '../MonthDisplay'
import { getEmployeeSelectorOptions, getProductSelectorOptions } from '../utils'
import css from './incentiveSales.css'
import IncentiveSalesGraph from './IncentiveSalesGraph'
import { fetchEmployeesList, fetchSalesIncentivesReport, incentiveSalesProductsQuery } from './incentiveSalesQueries'
import IncentiveSalesTable from './IncentiveSalesTable'
import IndexSection from './IndexSection'
type Props = {
  activeStation: any
}
type State = {
  month: moment.Moment
  selectedEmployee: string
  selectedProduct: string | null | undefined
}

@withActiveStation
class IncentiveSales extends Component<Props, State> {
  state = {
    month: moment(),
    selectedEmployee: '',
    selectedProduct: undefined,
  }
  onMonthChange = (step: number) => {
    this.setState({
      month: moment(this.state.month).add(step, 'month'),
    })
  }
  onChangeEmployee = (option: OptionType) => {
    this.setState({
      selectedEmployee: option.value,
    })
  }
  onChangeProduct = (option: OptionType) => {
    this.setState({
      selectedProduct: option.value,
    })
  }

  render() {
    const {
      activeStation: { id: stationId },
    } = this.props
    const { month, selectedEmployee, selectedProduct } = this.state
    return (
      <div>
        <div className={css.dropdownContainer}>
          <Query
            query={fetchEmployeesList}
            variables={{
              stationId,
            }}
          >
            {({ loading, data, error }) => {
              const employees = get(data, 'employees.edges', [])
              return (
                <div className={classnames(css.selector, css.dropdown)}>
                  <div className={css.selectorLabel}>{i18n.t('reporting.chooseEmployee')}</div>
                  <Select
                    options={getEmployeeSelectorOptions(employees, 'userId')}
                    onChange={this.onChangeEmployee}
                    value={selectedEmployee}
                  />
                </div>
              )
            }}
          </Query>
          <Query
            query={incentiveSalesProductsQuery}
            variables={{
              stationId,
              fromDate: moment(month).startOf('month').format('YYYY-MM-DD'),
              toDate: moment(month).endOf('month').format('YYYY-MM-DD'),
            }}
            fetchPolicy='network-only'
          >
            {({ loading, data, error }) => {
              const products = get(data, 'incentiveProductsSold', [])
              return (
                <div className={css.selector}>
                  <div className={css.selectorLabel}>{i18n.t('reporting.chooseProduct')}</div>
                  <Select
                    options={getProductSelectorOptions(products)}
                    onChange={this.onChangeProduct}
                    value={selectedProduct}
                  />
                </div>
              )
            }}
          </Query>
        </div>
        <Query
          query={fetchSalesIncentivesReport}
          variables={{
            stationId,
            userId: selectedEmployee,
            productId: selectedProduct,
            fromDate: moment(month).startOf('month').format('YYYY-MM-DD'),
            toDate: moment(month).endOf('month').format('YYYY-MM-DD'),
          }}
        >
          {({ loading, error, data }) => {
            console.log(selectedEmployee)
            const monthlyData = get(data, 'reportDailySalesIncentives', [])
            const stationSettings = get(data, 'stationSettings', [])
            const hasExpressCheckout =
              stationSettings.some((s: any) => s.name === 'ExpressCheckout') && !selectedEmployee
            return (
              <Loader
                {...{
                  loading,
                  error,
                }}
              >
                <IndexSection data={monthlyData} />
                <MonthDisplay selectedMonth={month} onMonthChange={this.onMonthChange} />
                <IncentiveSalesTable data={alphaSort('date', monthlyData)} hasExpressCheckout={hasExpressCheckout} />
                <IncentiveSalesGraph data={monthlyData} month={month} />
              </Loader>
            )
          }}
        </Query>
      </div>
    )
  }
}

export default IncentiveSales
